module.exports = "query VoucherUsers($voucherId:ID!){users(voucher_Id:$voucherId){edges{node{id email displayName}}}}"